import React from 'react';

import { TrussGroup } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { updateTrussGroup } from '../../../store/actions/trussGroups';
import { getProjectLayoutModel } from '../../../store/selectors/getProjectLayoutModel';
import { propertiesShouldBeViewOnly } from '../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { PropertiesPanelMenuButton } from './properties/PropertiesPanelMenuButton';
import { TrussGroupProperties } from './TrussGroupProperties';

export function TrussGroupPropertiesPanel(props: { value: TrussGroup }) {
  const dispatch = useAppDispatch();

  const trussGroups = useAppSelector((state) => state.trussGroups);
  const otherTrussGroups = Object.fromEntries(
    Object.entries(trussGroups).filter(([guid]) => guid !== props.value.guid),
  );
  const project = useAppSelector(getProjectLayoutModel);

  const disabled = useAppSelector(propertiesShouldBeViewOnly);

  if (!project) return null;

  return (
    <PropertiesPanel
      sx={{ gap: 2 }}
      title={props.value.name}
      titleButton={<PropertiesPanelMenuButton type="trussGroup" guid={props.value.guid} />}
    >
      <TrussGroupProperties
        trussGroup={props.value}
        onChange={(updatedTrussGroup) => void dispatch(updateTrussGroup({ ...props.value, ...updatedTrussGroup }))}
        otherTrussGroups={otherTrussGroups}
        disabled={disabled}
      />
    </PropertiesPanel>
  );
}
